export const SMALL_PAGE_LIMIT = 5
export const LARGE_PAGE_LIMIT = 15

export const weekRangeFormat = "dd MMM ''yy"
export const monthlyRangeFormat = 'MMM yyyy'
export const quarterlyRangeFormat = 'QQQ yyyy'
export const isoDateFormat = 'yyyy-MM-dd'

export const PENDING_STATES = ['pending', 'processing']
